import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-page-body-content",
    standalone: true,
    imports: [TranslateModule],
    templateUrl: "./page-body-content.component.html",
    styleUrl: "./page-body-content.component.scss",
})
export class PageBodyContentComponent {}
